const hondaData = require('./honda.js'); 
const mazdaData = require('./mazda.js');

module.exports = {
  data: {
    honda: hondaData,
    mazda: mazdaData
  },
};